import React from 'react';
import './myutils';
import { Route } from 'react-router-dom';
import Configuration from './configuration/Configuration';
import accessibility from './accessibility/accessibility'
import Statistics from './Statistics/Statistics';
import UnitsStatistics from './UnitsStatistics/UnitsStatistics';
import Softphone from './Softphone/Softphone';
import Customers from './Customers';

export default [
    <Route exact path="/Customers" component={Customers} />,
    <Route exact path="/Statistics" component={Statistics} />,
    <Route exact path="/UnitsStatistics" component={UnitsStatistics} />,
    <Route exact path="/Softphone" component={Softphone} />,
    <Route exact path="/configuration" component={Configuration} />,
    <Route exact path="/accessibility" component={accessibility} />,
];
